import HttpService from "./HttpService";

export default class ResourcesService extends HttpService {

    getIonicons() {
        let baseUrl = webase.utils.app.getBaseUrl()
        let url = baseUrl + '/resources/ionicons.json'
        this.get(url).then( (iconData) => {
            webase.model.ionIcons = iconData.icons
        })
    }

    getIconList() {
        let baseUrl = webase.utils.app.getBaseUrl()
        let url = baseUrl + '/resources/fa-list.json'
        this.get(url).then( (iconList) => {
            webase.model.icons = iconList
        })
    }

    getIcons() {
        let baseUrl = webase.utils.app.getBaseUrl()
        let url = baseUrl + '/resources/fa.json'
        this.get(url).then( (iconData) => {
            webase.model.iconsByCategory = iconData
            const allIcons = []
            const iconTypes = Object.keys(iconData)

            for( let i = 0; i < iconTypes.length; i++ ) {
                let iconType = iconTypes[i]
                let icons = iconData[iconType]

                for( let j = 0; j < icons.length; j++ ) {
                    let icon = icons[j]
                    allIcons.push(iconType + '-' + icon)
                }
            }

            webase.model.icons = allIcons
        })
    }
}